import { Badge } from "@/components/ui/badge";
import { STATUS, PRIORITY, slaInfo } from "@/lib/format";
import { Zap, Cable, Clock, HardHat } from "lucide-react";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || { label: status, cls: "" };
  return <Badge variant="outline" data-testid={testId} className={`rounded-sm font-medium whitespace-nowrap ${s.cls}`}>{s.label}</Badge>;
};

export const PriorityBadge = ({ priority }) => {
  const p = PRIORITY[priority] || PRIORITY.ORDINARIA;
  return <Badge variant="outline" className={`rounded-sm font-medium ${p.cls}`}>{p.label}</Badge>;
};

export const TypeBadge = ({ type }) => (
  <span className={`inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wider ${type === "ASSURANCE" ? "text-urgent" : "text-primary"}`}>
    {type === "ASSURANCE" ? <Zap className="h-3.5 w-3.5" /> : type === "CONSTRUCTION" ? <HardHat className="h-3.5 w-3.5" /> : <Cable className="h-3.5 w-3.5" />}
    {type === "ASSURANCE" ? "Assurance" : type === "CONSTRUCTION" ? "Construction" : "Delivery"}
  </span>
);

export const SlaChip = ({ order }) => {
  const s = slaInfo(order);
  if (!s) return null;
  const tone = s.tone === "breach" ? "bg-red-600 text-white" : s.tone === "warn" ? "bg-orange-100 text-urgent" : "bg-slate-100 text-slate-600";
  return (
    <span className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 font-mono text-[11px] ${tone}`}>
      <Clock className="h-3 w-3" />SLA {s.label}
    </span>
  );
};
